export function useTopTeacherList(key: string, filters?: { limit?: number }) {
  const cache = useTeacherCache();

  return useFetch("/api/teachers/top", {
    query: filters,
    server: true,
    default: () => [],
    transform(data) {
      if (!data) return [];

      const views = data.map((teacher) => toTeacherListView(teacher));

      cache.setMultiple(views);

      return views;
    },
  });
}
